import { __read } from "tslib";
import { mergeClasses } from '@fluentui/react-components';
import { useImageLoad } from '@office-start/image-utility';
import React, { useCallback, useMemo, useState } from 'react';
import { themeBackgroundGradient } from './constants';
import { ProtectedGradientControl } from './ProtectedGradientControl';
import { useVisualBackgroundStyles } from './VisualBackgroundControl.styles';
export var VisualBackgroundControl = function (_a) {
    var backgroundImageURL = _a.backgroundImageURL, backgroundGradient = _a.backgroundGradient, isHomePage = _a.isHomePage, isOpacity32 = _a.isOpacity32, themeId = _a.themeId, telemetryCallbacks = _a.telemetryCallbacks, visualBackgroundGradientEnabled = _a.visualBackgroundGradientEnabled, widthRestrictorOffset = _a.widthRestrictorOffset;
    var styles = useVisualBackgroundStyles();
    // Wait for image load
    var _b = __read(useState('loading'), 2), imageLoadState = _b[0], setImageLoadState = _b[1];
    var isImageLoaded = useMemo(function () {
        return imageLoadState === 'loaded';
    }, [imageLoadState]);
    // $TODO: If we're already in an unretriable error state, don't try to fetch the image again (ie 404)
    useImageLoad(backgroundImageURL, function (latency, isCached, _loadedEvent) {
        setImageLoadState('loaded');
        telemetryCallbacks.logVisualBackgroundImpression(latency, isCached);
    }, function (latency, errorEvent) {
        telemetryCallbacks.logVisualBackgroundError(latency, errorEvent);
        setImageLoadState('error');
    });
    var gradient = useMemo(function () {
        var _a;
        return isImageLoaded
            ? (_a = themeBackgroundGradient[themeId]) === null || _a === void 0 ? void 0 : _a[backgroundGradient]
            : '';
    }, [backgroundGradient, isImageLoaded, themeId]);
    var backgroundImageStyle = useMemo(function () {
        if (!visualBackgroundGradientEnabled) {
            return imageLoadState === 'loaded'
                ? {
                    backgroundImage: "".concat(gradient ? "".concat(gradient, ", ") : '', "url(").concat(backgroundImageURL, ")"),
                }
                : {};
        }
        else {
            return isImageLoaded
                ? {
                    backgroundImage: "url(".concat(backgroundImageURL, ")"),
                }
                : {};
        }
    }, [
        backgroundImageURL,
        gradient,
        imageLoadState,
        isImageLoaded,
        visualBackgroundGradientEnabled,
    ]);
    var backgroundGradientStyle = useMemo(function () {
        return isImageLoaded
            ? {
                backgroundImage: gradient,
            }
            : {};
    }, [gradient, isImageLoaded]);
    var getClassName = useCallback(function (divStyle) {
        return mergeClasses(styles.pageBackgroundCommonClass, divStyle, styles.pageTransitionBefore, isImageLoaded || imageLoadState === 'error'
            ? isHomePage
                ? styles.pageHomepageTransitionAfter
                : styles.pageCreateMyContentAppsModuleTransitionAfter
            : '', isImageLoaded && !isHomePage
            ? isOpacity32
                ? styles.m365Opacity
                : styles.orangeOpacity
            : '');
    }, [isHomePage, isImageLoaded, imageLoadState, isOpacity32, styles]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "visual-background-container", className: getClassName(styles.pageBackgroundImageDiv), style: backgroundImageStyle }),
        isImageLoaded && isHomePage && widthRestrictorOffset ? (React.createElement(ProtectedGradientControl, { backgroundGradient: backgroundGradient, themeId: themeId, widthRestrictorOffset: widthRestrictorOffset })) : null,
        gradient && visualBackgroundGradientEnabled ? (React.createElement("div", { className: getClassName(styles.pageBackgroundGradientDiv), style: backgroundGradientStyle })) : null));
};
//# sourceMappingURL=VisualBackgroundControl.js.map